import { render, staticRenderFns } from "./TaskCompletionModal.vue?vue&type=template&id=134eb90a&"
import script from "./TaskCompletionModal.vue?vue&type=script&lang=ts&"
export * from "./TaskCompletionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports